/* Shared, deterministic eligibility rules. No customer identifiers are stored. */
(function (scope) {
  const DAY = 86400000;
  function reason(context) {
    const { now, record = {}, customer = {}, pathname = '/', template = '', emailVisit, designMode } = context;
    if (designMode) return 'theme-editor';
    if (!['index', 'product', 'collection', 'blog', 'article'].includes(template)) return 'page';
    if (/\/(cart|checkout|checkouts|account|challenge|password|policies)(\/|$)/.test(pathname)) return 'page';
    if (customer.subscribed || customer.orders > 0) return 'known-customer';
    if (emailVisit) return 'email-visit';
    if (record.submittedAt && now - record.submittedAt < 365 * DAY) return 'submitted';
    if (record.dismissedAt && now - record.dismissedAt < 7 * DAY) return 'dismissed';
    if (record.shownAt && now - record.lastActivity < 30 * 60000) return 'session';
    return null;
  }
  const api = { reason, DAY };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.SeriniaPopupRules = api;
})(typeof window !== 'undefined' ? window : globalThis);
